export type ReportIntent={version:1;requestId:string;useAI:boolean;createdAt:number};
export const UUID_PATTERN=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function key(owner:string){if(!UUID_PATTERN.test(owner))throw new Error('Личность пользователя не подтверждена.');return 'spiritual.ai-operation.v1:'+owner;}
export function loadReportIntent(owner:string):ReportIntent|null{
 const raw=localStorage.getItem(key(owner));if(raw===null)return null;
 let data;try{data=JSON.parse(raw);}catch{throw new Error('Журнал операции повреждён. Новая генерация заблокирована.');}
 if(!data||Object.keys(data).sort().join(',')!=='createdAt,requestId,useAI,version'||data.version!==1||typeof data.requestId!=='string'||!UUID_PATTERN.test(data.requestId)||typeof data.useAI!=='boolean'||!Number.isSafeInteger(data.createdAt)||data.createdAt<=0)throw new Error('Журнал операции повреждён. Новая генерация заблокирована.');
 return data;
}
async function locked<T>(owner:string,action:()=>T):Promise<T>{
 if(!navigator.locks?.request)throw new Error('Безопасное создание отчёта недоступно в этом браузере. Используйте актуальный браузер через HTTPS.');
 return navigator.locks.request(key(owner),()=>action());
}
export async function ensureReportIntent(owner:string,useAI:boolean):Promise<ReportIntent>{
 return locked(owner,()=>{
  const existing=loadReportIntent(owner);
  if(existing){if(existing.useAI!==useAI)throw new Error('Сначала проверьте результат сохранённой операции.');return existing;}
  if(!globalThis.crypto?.randomUUID)throw new Error('Браузер не поддерживает безопасное создание операции.');
  const intent:ReportIntent={version:1,requestId:crypto.randomUUID(),useAI,createdAt:Date.now()};
  const serialized=JSON.stringify(intent);
  try{localStorage.setItem(key(owner),serialized);if(localStorage.getItem(key(owner))!==serialized)throw new Error();}
  catch{throw new Error('Не удалось сохранить операцию. Запрос к модели не отправлен.');}
  return intent;
 });
}
export async function releaseReportIntent(owner:string,expectedId:string):Promise<void>{
 return locked(owner,()=>{if(loadReportIntent(owner)?.requestId!==expectedId)throw new Error('Операция изменилась в другой вкладке. Обновите состояние.');localStorage.removeItem(key(owner));});
}
